import React, { useState, useEffect } from 'react';
const Pagination = ({ totalPages, totalRecords, visibleCount = 5, onPageSizeChange, onPageChange, currentPage }) => {

  const [pageSize, setPageSize] = useState(25);

 useEffect(() => {
  
    onPageSizeChange(pageSize, currentPage);
 
 }, [pageSize, currentPage]);


  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  const getVisiblePages = () => {
    const pages = [];

  if (totalPages <= visibleCount) {
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
    return pages;
  }

    if (currentPage >= totalPages - visibleCount + 2) {
      pages.push(1);
      pages.push('start-ellipsis');

      const start = totalPages - visibleCount + 1;
      for (let i = start; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      let start = Math.max(currentPage - Math.floor(visibleCount / 2), 1);
      let end = start + visibleCount - 1;

      if (end > totalPages) {
        end = totalPages;
        start = Math.max(end - visibleCount + 1, 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (end < totalPages) {
        pages.push('end-ellipsis');
        pages.push(totalPages);
      }
    }

    return pages;
  };

  const visiblePages = getVisiblePages();

  return (
    <div className="pagination-row" style={{ display: 'flex', alignItems: 'center', gap: '20px', flexWrap: 'wrap',justifyContent: 'space-between' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <span>Total Records: {totalRecords}</span>
        Page Size: <select
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
            onPageChange(1); // Reset to first page
          }}
        >
          {[25, 50, 75, 100].map(size => (
            <option key={size} value={size}>{size}</option>
          ))}
        </select>
      </div>

      <div className="pagination" style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
        <button onClick={() => goToPage(1)} disabled={currentPage === 1}>«</button>
        <button onClick={() => goToPage(currentPage - 1)} disabled={currentPage === 1}>‹</button>

        {visiblePages.map((page, index) => {
          if (page === 'start-ellipsis' || page === 'end-ellipsis') {
            return <span key={`ellipsis-${index}`} className="ellipsis">…</span>;
          }

          return (
            <button
              key={page}
              className={page === currentPage ? 'active' : ''}
              onClick={() => goToPage(page)}
              style={{
                padding: '6px 10px',
                border: '1px solid #ccc',
                backgroundColor: page === currentPage ? '#5c3d8e' : '#f8f8f8',
                color: page === currentPage ? '#fff' : '#000',
                fontWeight: page === currentPage ? 'bold' : 'normal',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              {page}
            </button>
          );
        })}

        <button onClick={() => goToPage(currentPage + 1)} disabled={currentPage === totalPages}>›</button>
        <button onClick={() => goToPage(totalPages)} disabled={currentPage === totalPages}>»</button>
      </div>
    </div>
  );
};

export default Pagination;
